<script>
    import Route, {router} from "../lib/Router/Router.svelte";
    import R, {LOADER} from "../lib/requests";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import PageHeader from "../components/PageHeader.svelte";
    import Breadcrumb from "../components/Breadcrumb.svelte";
    import AccountData from "./AccountData.svelte";
    import AccountDepartments from "./AccountDepartments.svelte";
    import AccountHotels from "./AccountHotels.svelte";
    import HotelEdit from "../hotels/HotelEdit.svelte";
    import DepartmentEdit from "../departments/DepartmentEdit.svelte";
    import PageNotFound from "../components/pages/PageNotFound.svelte";
    import {setFocusTo, randomColor, copyObjectData, getIdFromUrl, scrollTo} from "../lib/lib";

    export let accountId = null;
    export let accountPath = null;
    export let updateCallback;

    let breadcrumb = [
        {id: 'accounts', name: 'Accounts', link: `/app/account`}
    ];

    let account = null;
    let pageTitle = '';
    let hotelId = null;
    let departmentId = null;

    const initialize = () => {
        if (accountId === 'create') {
            accountId = 0;
            account = {
                id: 0,
                color: randomColor(),
                name: '',
                contact_person: '',
                email: '',
                phone: '',
                mobile: '',
                address: '',
                vat: '',
                tax_office: '',
                notes: '',
                is_active: 1,
                hotels: [],
            };
            pageTitle = "New Account";
            setFocusTo('accountName');
        } else {
            load();
        }
    }

    const load = () => {

        const onSuccess = result => {
            account = result;
            pageTitle = result.name;

            hotelId = getIdFromUrl('hotel');
            departmentId = getIdFromUrl('department');
            if (!hotelId && !departmentId) {
                setFocusTo('accountName');
            }
        }

        const onFailure = err => {
            accountId = -1;
        };

        R.handle(R.account.details, accountId, onSuccess, onFailure, LOADER.PAGE);
    };

    const onCreateHotel = () => {
        hotelId = 0;
        router.go(`/app/account/${accountId}/hotel/create`)();
    }

    const onEditHotel = ({detail: id}) => {
        hotelId = id;
        router.go(`/app/account/${accountId}/hotel/${id}`)();
    }

    const updateHotel = (hotel) => {
        console.log("updateHotel", hotel);
        if (!hotel) {
            backToAccount();
        } else {
            let item = account.hotels.find(x => x.id == hotel.id);
            if (item) {
                copyObjectData(hotel, item);
                account.hotels = account.hotels;
            } else {
                account.hotels = [hotel, ...account.hotels];
            }
        }
    }

    const onCreateDepartment = () => {
        console.log("onCreateDepartment");
        departmentId = 0;
        router.go(`/app/account/${accountId}/department/create`)();
    }

    const onEditDepartment = ({detail: id}) => {
        departmentId = id;
        router.go(`/app/account/${accountId}/department/${id}`)();
    }

    const updateDepartment = (department) => {
        console.log("updateDepartment", department);
        if (!department) {
            backToAccount();
        } else {
            let item = account.departments.find(x => x.id == department.id);
            if (item) {
                copyObjectData(department, item);
                account.departments = account.departments;
            } else {
                account.departments = [department, ...account.departments];
            }
        }
    }

    const backToAccount = () => {
        breadcrumb = breadcrumb.filter(x => x.id === 'accounts');
        hotelId = null;
        departmentId = null;
        scrollTo('top');
        router.go(`/app/account/${accountId}`)();
    }

    initialize();

</script>

<Breadcrumb {breadcrumb} on:account="{ backToAccount }"/>
{#if account}
    {#if hotelId != null}
        <HotelEdit hotelId="{ hotelId }" {account} bind:breadcrumb={ breadcrumb } updateCallback="{ updateHotel }"/>
    {:else if departmentId != null}
        <DepartmentEdit {departmentId} {account} bind:breadcrumb={ breadcrumb } updateCallback="{ updateDepartment }"/>
    {:else}
        <PageHeader title="{ pageTitle }"/>
        <div class="row">
            <div class="col-xl-6 col-lg-7 col-md-6">
                <AccountData bind:account={ account } updateCallback="{ updateCallback }"/>
            </div>
            <div class="col-xl-3 col-lg-5 col-md-6">
                <AccountDepartments {account} on:create="{ onCreateDepartment }" on:edit="{ onEditDepartment }"/>
                <AccountHotels {account} on:create="{ onCreateHotel }" on:edit="{ onEditHotel }"/>
            </div>
        </div>
    {/if}
{/if}
{#if accountId == -1}
    <PageNotFound message="Account not found!"/>
{/if}
